import { buildQuery } from '@/lib/helper';
import client from '@/lib/http-client';

const endpoint = '/activity_logs';

export default {
	getList(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	getDetail(activityLogId, params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/${activityLogId}?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
